module.exports = __webpack_public_path__ + "img/ambulance-night-thumb.08995fdc.jpg";